/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OidcConfig } from './OidcConfig';
import {
    OidcConfigFromJSON,
    OidcConfigFromJSONTyped,
    OidcConfigToJSON,
    OidcConfigToJSONTyped,
} from './OidcConfig';

/**
 * Result of domain or email discovery for SSO configuration
 * @export
 * @interface DomainLookupResult
 */
export interface DomainLookupResult {
    /**
     * Whether the domain/email was found
     * @type {boolean}
     * @memberof DomainLookupResult
     */
    found?: boolean;
    /**
     * Error message if not found
     * @type {string}
     * @memberof DomainLookupResult
     */
    error?: string;
    /**
     * Domain name
     * @type {string}
     * @memberof DomainLookupResult
     */
    domain?: string;
    /**
     * Customer ID
     * @type {string}
     * @memberof DomainLookupResult
     */
    customerId?: string;
    /**
     * Customer name
     * @type {string}
     * @memberof DomainLookupResult
     */
    customerName?: string;
    /**
     * Keycloak alias
     * @type {string}
     * @memberof DomainLookupResult
     */
    keycloakAlias?: string;
    /**
     * Provider type (azure, okta, local)
     * @type {string}
     * @memberof DomainLookupResult
     */
    providerType?: string;
    /**
     * Provider configuration map (OAuth details)
     * @type {{ [key: string]: any; }}
     * @memberof DomainLookupResult
     */
    providerConfig?: { [key: string]: any; };
    /**
     * OIDC configuration for building authorization URLs (provider-agnostic)
     * @type {OidcConfig}
     * @memberof DomainLookupResult
     */
    oidcConfig?: OidcConfig;
}

/**
 * Check if a given object implements the DomainLookupResult interface.
 */
export function instanceOfDomainLookupResult(value: object): value is DomainLookupResult {
    return true;
}

export function DomainLookupResultFromJSON(json: any): DomainLookupResult {
    return DomainLookupResultFromJSONTyped(json, false);
}

export function DomainLookupResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainLookupResult {
    if (json == null) {
        return json;
    }
    return {
        
        'found': json['found'] == null ? undefined : json['found'],
        'error': json['error'] == null ? undefined : json['error'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'keycloakAlias': json['keycloakAlias'] == null ? undefined : json['keycloakAlias'],
        'providerType': json['providerType'] == null ? undefined : json['providerType'],
        'providerConfig': json['providerConfig'] == null ? undefined : json['providerConfig'],
        'oidcConfig': json['oidcConfig'] == null ? undefined : OidcConfigFromJSON(json['oidcConfig']),
    };
}

export function DomainLookupResultToJSON(json: any): DomainLookupResult {
    return DomainLookupResultToJSONTyped(json, false);
}

export function DomainLookupResultToJSONTyped(value?: DomainLookupResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'found': value['found'],
        'error': value['error'],
        'domain': value['domain'],
        'customerId': value['customerId'],
        'customerName': value['customerName'],
        'keycloakAlias': value['keycloakAlias'],
        'providerType': value['providerType'],
        'providerConfig': value['providerConfig'],
        'oidcConfig': OidcConfigToJSON(value['oidcConfig']),
    };
}

